import { render, staticRenderFns } from "./BoardsDetailsView.vue?vue&type=template&id=2402b423&scoped=true"
import script from "./BoardsDetailsView.vue?vue&type=script&lang=js"
export * from "./BoardsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./BoardsDetailsView.vue?vue&type=style&index=0&id=2402b423&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2402b423",
  null
  
)

export default component.exports